import * as UnitTimes from "./unit-times";
export function Cubed(name, u) {
    var area = UnitTimes.lengthByLength(name, u, u);
    return UnitTimes.areaByLength(name, area, u);
    // TODO was return u.Times < IArea > (u).Times < IVolume > (u);
}
//# sourceMappingURL=unit-cubed.js.map